module.exports = __webpack_public_path__ + "media/images/redesign-images/home/utees-life-1-55dd0687ee110e86bbd324f3bdc764d4.jpg";